// src/progress/migrateLocalProgress.js

const LS_KEY = "userProgress";
const MIGRATION_FLAG_PREFIX = "progress_migrated_v1:"; // per-user flaga

function readJSON(key, fallback) {
  try { return JSON.parse(localStorage.getItem(key)) ?? fallback; } catch { return fallback; }
}

function normalizedStatus(score, maxScore) {
  if (typeof score === "number" && typeof maxScore === "number" && maxScore > 0) {
    return score >= maxScore ? "solved" : "started";
  }
  return "started";
}

function normalizedRatio(score, maxScore) {
  if (typeof score === "number" && typeof maxScore === "number" && maxScore > 0) {
    const r = score / maxScore;
    return Math.max(0, Math.min(1, r));
  }
  return undefined;
}

/**
 * Migruje localStorage.userProgress[email] -> POST /api/progress/bulk-upsert
 * Nie usuwa danych z LS; tylko ustawia flagę, by nie migrować ponownie.
 */
export async function migrateLocalProgressForUser(userEmail, authorizedFetch) {
  if (!userEmail || !authorizedFetch) return;
  const flagKey = `${MIGRATION_FLAG_PREFIX}${userEmail}`;
  if (localStorage.getItem(flagKey) === "1") return; // już zrobione

  const all = readJSON(LS_KEY, {});
  const entries = all?.[userEmail] || {};
  const lessonIds = Object.keys(entries);
  if (!lessonIds.length) {
    localStorage.setItem(flagKey, "1");
    return;
  }

  const items = lessonIds.map((lessonId) => {
    const { score, maxScore, timestamp } = entries[lessonId] || {};
    return {
      taskId: lessonId,                           // 1:1 z Twoim obecnym kluczem
      status: normalizedStatus(score, maxScore),  // "solved" | "started"
      score: normalizedRatio(score, maxScore),    // 0..1 (opcjonalne, jeśli znane)
      // topicId: mapLessonToTopic(lessonId),     // (opcjonalnie dorobimy później)
      lastAnswer: "",
      localTimestamp: timestamp || new Date().toISOString(),
    };
  });

  try {
    const res = await authorizedFetch("/api/progress/bulk-upsert", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items }),
    });
    if (res.ok) {
      localStorage.setItem(flagKey, "1"); // nie migruj ponownie
    }
  } catch {
    // brak sieci itp. — spróbujemy przy następnym logowaniu
  }
}
